import React, { FC } from 'react';
import { ResetPassword } from './ResetPassword';
import { Header } from '../../../shared/components';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { PageLayout } from '../../../shared/layout/page/PageLayout';

export const ResetPasswordPage: FC = () => {
	const { t } = useTranslation();

	return (
		<PageLayout hideFooterOnMobile>
			<Header theme="green-blue" title={t('web_reset_password_header')} />
			<ResetPassword />
		</PageLayout>
	);
};
